function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.17 14.61V7.13L28.6 9.5c.86.8 2.2.8 3.05-.02.85-.82.85-2.13.01-2.94L25.51.61c-.4-.4-.96-.6-1.5-.6L23.99 0c-.56 0-1.1.22-1.51.6l-6.16 5.93a2.03 2.03 0 00.02 2.94c.85.82 2.19.83 3.05.02l2.44-2.36v11.65h-6.5v-4.17H8.82a4.24 4.24 0 00-4.32 4.16v25.07c0 2.3 1.93 4.16 4.32 4.16h30.36a4.24 4.24 0 004.32-4.16V18.77c0-2.3-1.94-4.16-4.32-4.16h-6.52v4.17h6.5v25.05H8.84V18.78h13v8.35c.03 1.17 1 2.1 2.17 2.08 1.2 0 2.17-.93 2.17-2.08V14.61z"
})));